/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocArrowConvertIcon20Solid = forwardRef('DocArrowConvertIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m15.863 6.498-4.358-4.359v3.609c0 .414.335.75.75.75h3.608Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 2h3.005v3.748a2.25 2.25 0 0 0 2.25 2.25H16V15a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-2.3h4.665l-1.193 1.05a.8.8 0 1 0 1.056 1.2l2.203-1.936a1.55 1.55 0 0 0 0-2.328L8.528 8.749a.8.8 0 0 0-1.056 1.202L8.665 11H4V7.7h-.5a1.65 1.65 0 1 0 0 3.3H4v1.7h-.5a3.35 3.35 0 1 1 0-6.7H4V5a3 3 0 0 1 3-3Z" })));
});
